<template>
  <div class="template">
    <!-- <img class="top-picc-2" src="@/assets/images/template/picc-icon2.jpg" /> -->
    <div class="redline"></div>
    <div class="top-title">鑫换新车辆事故保障服务函</div>
    <div class="num-con">
      编号：
      <span class="num">{{showDate.saleslip.pnum}}</span>
    </div>
    <table class="temTable" border="0" cellspacing="0" cellpadding="0">
      <tr>
        <td>
          <div class="p-content">
            
            <span class="key">“青岛鑫诚泰网络科技有限公司”</span>销售的
            <span class="key">“鑫换新车辆事故保障服务函”</span>服务函中双方约定的服务期限、服务范围、服务责任、赔偿处理、索赔材料的内容如下：
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="key">一.服务期限：</div>
          <div
            class="p-content"
          >自服务生效之日起{{swapper(selectYear)}}年有效。在服务期限内，如发生车辆转让，该保障服务立即中止。</div>
        </td>
      </tr>
      <tr>
        <td>
          <span class="key">二.服务范围：中华人民共和国境内（港、澳、台除外），9 座及以下的家庭自用的新车、非营运新车；车
辆类型为：非进口车。</span>
<div class="p-content">
1、1.1按照新车购买发票日期，原厂质保期为约定的车辆，自新车销售之日起1个月（含）且行驶里程在1000公里（含）以内；月龄或行驶里程超出此约定不予承保；1.2次新车：6-24月/小于60000KM ；1.3次新车投保前未出大事故，即单次事故定损额不超过新车购置价30%。
2、车辆投保时不存在重大事故；车辆的性能、动力没有被改装过；车辆非水泡、火烧车；
3、车辆出险时已经全额投保机动车损失保险；
4、车辆必须按照厂家车辆使用手册、厂家说明书等相关规定使用；
5、车辆使用性质为非公共服务用途车辆、非比赛竞赛用车。
</div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="key">三.保障责任：在服务有效期内，当标的车辆遭遇交通事故后，所产生的商业保险所保障的各类车损，包括车辆驾驶人在此次交通事故责任认定中属于主要责任、同等责任、次要责任或无责任（非单车事故），如标的车辆的车损在本次事故中经商业车险公司核定的修理费达到或超过本服务函赔付标准(以购车发票金额为准)，可以通过原购买服务的门店申请相关保障赔付。
          </div>
        </td>
      </tr>

<tr>
        <td>
          <div class="key">四.赔付标准：</div>
          <div class="p-content">
1、定损金额≥新车购置价30%且非全损及推定全损：
1.1客户在服务合同规定的期限内提出新车购置要求：原车辆发票价+原新车购置税+上牌费1000元给到汽车经销商；
1.2如选择不换新车，可申请定损金额*50%的现金补偿；
1.3单方事故只能申请定损金额*50%的现金补偿。
2、维修费用达到全损及推定全损：补偿该车折旧+原新车购置税上牌费1000元，用于客户置换新车；
车辆折旧费用=原车购置价 X 车辆已使用月数 X 月折旧率月折旧率按千分之6计算。
特别说明：1、须在原经销商处购买新车时，方可享受机动车置换补偿服务；2、受服务车辆发生车损事故后，须在原经销商处进行维修，更换原厂配件，符合二手车检验标准；3、车辆所有人在购车时使用了配套贷款，须办理完解押手续后，方可申请机动车置换补偿服务；4、新车次新车赔付标的均按照原购车发票为准。
      </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="key">五.除外责任：出现下列任一情形时，本服务不负责赔偿:
            1、当机动车遭受损害事故仅导致部分损失时，定损金额未达到新车购置价30%；2、当机动车遭受损害事故仅导致部分损失时，未能提供相关车辆投保商业车险的承保公司出具的赔偿协议或证明的；3、机动车的客户身份认证信息、车辆使用性质与服务合同中记载不一致的；4、机动车所有人与服务合同客户不一致的；5、机动车遭受的损害事故发生在服务合同生效前，或客户未在服务合同规定的期限内提出新车购置要求；特别说明：车辆事故发生后，车主应当在24小时内向商业险保险公司及交管部门报案，同时致电青岛鑫诚泰全国统一客户热线4006601517进行备案，并通过本公司向保险公司索赔，索赔时按照保险公司的要求提供相关材料；6、换新保障生效期间该车辆未在购买车辆经销店保养、事故维修（如有，不分大小事故）、保险续保；7、在购置新车过程中，车主更换品牌等原因产生的额外费用；8、任何形式的人身伤害、财产损失，及除本合同所列车辆置换费用外其他任何费用支出；9、机动车全损及购置新车的过程中所产生的任何间接损失、赔偿责任；10、客户酒驾、醉驾、欺诈、不诚实、违法犯罪行为；11、客户使用、维护、保管不当；12、战争、敌对行为、军事行动、武装冲突、恐怖主义活动、罢工、暴动、骚乱、核爆炸、核裂变、核聚变；13、放射性污染及其他各种环境污染；14、行政行为、司法行为；15、自然灾害所致的车辆直接或间接损失；16、因车辆被盗窃、抢劫、抢夺或在被盗窃、抢劫、抢夺期间发生事故所造成的损失；17、车辆在非正常使用环境下，如车辆检测、修理、养护，被诈骗、扣押、征用、没收期间发生的损失、费用和责任。
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="key">六.索赔资料：发生保险责任事故时，车主应配合提供相应索赔材料：
 1、原购车发票原件影印件、《机动车置换服务合同》原件；2、承保车辆行驶本原件电子版、车主驾驶本原件电子版、车主身份证原件电子版；3、相关车险保单原件电子版；4、原车辆购置税缴费凭证；5、原车辆所有钥匙；6、保险公司定损报告；7、车辆全损后处理手续；（权益转让书、拍卖或注销解体手续）8、事故发生原因证明，属于道路交通事故的提供事故证明；自燃的提供消防部门证明等等；（证明材料复印件，车险保险公司盖章）9、车辆维修费清单；店端给保险公司开具的维修发票原件电子版、维修赔付完毕证明；（划账水单、一次性赔偿协议原件或车险公司盖章的复印件）10、保险公司所要求的其他索赔材料。
          </div>
        </td>
      </tr>
    </table>
    <div class="personal-title">车辆信息</div>
    <table class="personal-table" border="0" cellspacing="0" cellpadding="0">
      <tr>
        <td width="130">车主姓名</td>
        <td colspan="2">{{showDate.saleslip.customername}}</td>
        <td width="130">证件号码</td>
        <td colspan="2">{{showDate.saleslip.certificatenum}}</td>
      </tr>
      <tr>
        <td>固定电话</td>
        <td colspan="2"></td>
        <td>移动电话</td>
        <td colspan="2">{{showDate.saleslip.phone}}</td>
      </tr>
      <tr>
        <td>联系地址</td>
        <td colspan="2">{{showDate.saleslip.address}}</td>
        <td>产品金额</td>
        <td colspan="2">{{showDate.saleslip.policyamount}}</td>
      </tr>
      <tr>
        <td>车牌号码</td>
        <td colspan="2">{{showDate.saleslip.carnum}}</td>
        <td width="130">车辆登记日期</td>
        <td colspan="2">{{this.$formatTimeCN(showDate.saleslip.buytime, 'yyyy-MM-dd')}}</td>
      </tr>
      <tr>
        <td>发动机号</td>
        <td colspan="2">{{showDate.saleslip.enginenum}}</td>
        <td >车架号</td>
        <td colspan="2">{{showDate.saleslip.frame}}</td>
      </tr>
      <tr>
        <td>服务期限</td>
        <td colspan="5">
          自{{this.$formatTimeCN2(showDate.saleslip.installtime)}}至{{getendTime($formatTimeCN2(showDate.saleslip.pstarttime))}}止
          </td>
        </tr>
    </table>
    <p class="tips"></p>
    <p
      class="tips"
    >产品销售公司：(签章)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;车主签名：</p>
    <p class="tips">有效期:{{getendTime($formatTimeCN2(showDate.saleslip.pstarttime))}}</p>
    <p class="tips">全国统一客服热线：4006601517</p>
    <!-- <img class="inis2-3" src="@/assets/images/inis2-2.png" alt /> -->
    <img class="inis-1" src="@/assets/images/inis.png" alt />
  </div>
</template>
<script>
export default {
  props: ["showDate", "selectYear"],
  data() {
    return {};
  },
  mounted() {
    // this.ini ()
  },
  methods: {
    swapper(n) {
      switch (n) {
        case 1:
          return "壹";
        case 2:
          return "贰";
        case 3:
          return "叁";
        case 4:
          return "肆";
        case 5:
          return "伍";
      }
    },
    getendTime(str) {
      str = str.split("年");
      let tempdata = Number(str[0]);
      str[0] = tempdata += this.selectYear;
      return str.join("年");
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/template/s14.vue